import { render, staticRenderFns } from "./AyudaParte2CultivoSmolt.vue?vue&type=template&id=31a18025&scoped=true"
import script from "./AyudaParte2CultivoSmolt.vue?vue&type=script&lang=js"
export * from "./AyudaParte2CultivoSmolt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a18025",
  null
  
)

export default component.exports